import React, { useState, useEffect, useRef, useContext } from 'react';
import { withTranslation } from "react-i18next";
import ReportAIService from '../../core/service/ReportAIService';
import esg_ai from '../../images/esg_ai.png';
import esg_green from '../../images/esg_ai_Green.png';

import './AIReportChat.scss';
import { Button, Modal, OverlayTrigger, Spinner } from 'react-bootstrap';
import { Bar, Doughnut, Line } from "react-chartjs-2";
import { BiMenuAltLeft, BiSolidUpArrow, BiX } from "react-icons/bi";
import { BsTable, BsGraphDown } from "react-icons/bs";
import { MdSend } from 'react-icons/md';
import { toast } from 'react-toastify';
import { LS_AUTHORITY_KEY, LS_UI_ELEMENTS_CONFIG_KEY, CWD_ID } from '../../core/constants/common';
import Utils from '../../core/utilities/Utils';
import AIChatHistory from './AIChatHistory';
import ReportingUtils from '../../core/utilities/ReportingUtils';
import { ChatShowContext } from '../../App';
import { FaHandPointRight } from "react-icons/fa";

const AIReportChat = ({ t, onTransferToEditor }) => {

	const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const [cwdId, setCwdId] = useState(localStorage.getItem(CWD_ID) ?? null);
	const companyId = lsDat.profile.company.id;
	const userId = lsDat.profile.user.id;
	const uiElementsConfig = JSON.parse(localStorage.getItem(LS_UI_ELEMENTS_CONFIG_KEY)) ?? null;

	const [maximized, setMaximized] = useState(true);
	const [questions, setQuestions] = useState({});
	const [answers, setAnswers] = useState({});
	const [message, setMessage] = useState('');
	const [loadingAns, setLoadingAns] = useState({});
	const [show, setShow] = useState(false);
	const [thoughtsDisplay, setThoughtsDisplay] = useState({});
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const chatEndRef = useRef(null);
	const [errorMessage, setErrorMessage] = useState('');
	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const [showTable, setShowTable] = useState({});
	const [showgraph, setShowgraph] = useState({});

	const [tableOrder, setTableOrder] = useState(0);
	const [graphOrder, setGraphOrder] = useState(0)
	const chartRef = useRef([]);
	const [displayMessage, setDisplayMessage] = useState('Gathering data...');
	const { showChat, setShowChat } = useContext(ChatShowContext);
	let profileData = null;
	if (lsData !== "") {
		profileData = lsData?.profile?.user;
	}

	useEffect(() => {
		scrollToBottom();
		if (cwdId == null) {
			getCWDId();
		}
	}, [questions, answers, errorMessage, showTable, showgraph]);

	useEffect(() => {
		setShowChat('Reporting');
		return () => {
			setShowChat('Global');
		}
	});

	const sendMessage = () => {
		if (message && cwdId) {
			const qData = JSON.parse(JSON.stringify(questions));
			const qIndex = Date.now();
			qData[`${qIndex}`] = {
				message: message,
				time: qIndex
			};
			setQuestions(qData);
			const loadingData = JSON.parse(JSON.stringify(loadingAns));
			loadingData[qIndex] = true;
			setLoadingAns(loadingData);
			const payload = {
				query: message,
				company_id: companyId,
				user_id: `${userId}`,
				cwd_id: cwdId
			};
			analyzeQuestion(qIndex);
			scrollToBottom();
			setMessage('');
		}
	};

	const toggleGraphVisibility = () => {
		setShowgraph(!showgraph);
	};
	const scrollToBottom = () => {
		chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
	};

	const fetchStreamedChatDataNew = async (payload, qIndex) => {
		try {
			//setErrorMessage('')
			const response = await fetch(ReportAIService.ChatWithDataStreamedAPIURLNew, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(payload)
			});
			if (response.status === 400) {
				const errorResponse = await response.json();
				setErrorMessage(errorResponse.detail); // Set error message state
				const loadingData = JSON.parse(JSON.stringify(loadingAns));
				loadingData[qIndex] = false;
				setLoadingAns(loadingData);
				return;
			}
			const reader = response.body.getReader();
			// Hide loader
			const loadingData = JSON.parse(JSON.stringify(loadingAns));
			loadingData[qIndex] = false;
			setLoadingAns(loadingData);
			scrollToBottom();
			let result = '';
			if (response.status === 200) {
				while (true) {
					const { done, value } = await reader.read();
					if (done) break;

					result += new TextDecoder('utf-8').decode(value);
					const ansData = JSON.parse(JSON.stringify(answers));
					ansData[`${qIndex}`] = {
						message: result,
					};
					setAnswers(ansData);
				}
				const logId = response.headers.get('X-Log-Id');
				const ansData = JSON.parse(JSON.stringify(answers));
				ansData[`${qIndex}`] = {
					message: result,
					logId: logId,
				};
				setAnswers(ansData);
				if (!logId) return;

				fetchGraphData(payload, qIndex, logId);
			} else {
				setLoadingAns(loadingData);
				return errorHandler(response);
			}
		} catch (error) {
			const loadingData = JSON.parse(JSON.stringify(loadingAns));
			loadingData[qIndex] = false;
			setLoadingAns(loadingData);
			console.error('Error fetching data:', error);
		}
	};

	const fetchGraphData = (payload, qIndex, logId) => {
		ReportAIService.visualize(payload, companyId, logId).then(res => {
			const loadingData = JSON.parse(JSON.stringify(loadingAns));
			loadingData[qIndex] = false;
			setLoadingAns(loadingData);
			if (res.status !== 200)

				return;

			const ansData = JSON.parse(JSON.stringify(answers));
			setAnswers(existingAnswers => {
				existingAnswers[qIndex].graphData = res.data.graph_data;
				existingAnswers[qIndex].graphType = res.data.graph_type;
				existingAnswers[qIndex].time = Date.now();
				existingAnswers[qIndex].thoughts = res.data.chain_of_thoughts;
				existingAnswers[qIndex].message = res.data.insight ?? existingAnswers[qIndex].message;
				existingAnswers[qIndex].tableContent = res.data.html_table_content;
				return existingAnswers;
			});
		}).catch(err => {
			const loadingData = JSON.parse(JSON.stringify(loadingAns));
			loadingData[qIndex] = false;
			setLoadingAns(loadingData);
			scrollToBottom();
		});
	};

	const onEnterPress = (e) => {
		if (e.keyCode == 13 && e.shiftKey == false) {
			e.preventDefault();
			sendMessage();
		}
	};

	const dataToTransfer = (data, type, index) => {
		switch (type) {
			case 'text':
				const textData = '<p>' + data.message + '</p>';
				onTransferToEditor(textData, null);
				break;
			case 'table':
				const tableData = createMarkups(data?.tableContent);
				onTransferToEditor(tableData.__html, null);
				break;
			case 'graph':
				// const base64Image = chartRef.current[index].toBase64Image().replace('data:image/png;base64,', '');
				const graphData = '<img src="data:image/jpeg;base64,' + data.graphData + '" alt="Graph" />';
				onTransferToEditor(graphData, null);
				break;
			default:
				break;
		}
	}

	const getCWDId = () => {
		let passData = {
			company_id: companyId,
			user_id: String(userId)
		}
		ReportAIService.getCWDId(passData)
			.then(res => {
				localStorage.setItem(CWD_ID, res.data.cwd_id);
				setCwdId(res.data.cwd_id);
			})
			.catch((error) => {
			});
	}

	const analyzeQuestion = (qIndex) => {
		let payload = {
			query: message,
			company_id: companyId,
			user_id: `${userId}`,
			cwd_id: cwdId
		};
		setDisplayMessage('Analysing...');
		let resData = null;
		ReportAIService.analyzeQn(payload)
			.then(res => {
				if (res.status === 400) {
					setErrorMessage(res.data.detail);
					const loadingData = JSON.parse(JSON.stringify(loadingAns));
					loadingData[qIndex] = false;
					setLoadingAns(loadingData);
				} else {
					resData = res.data;
					if (resData.action === 'small_talk') {
						const ansData = JSON.parse(JSON.stringify(answers));
						ansData[`${qIndex}`] = {
							message: resData.response,
							logId: resData.log_id,
							sample_q1: resData.sample_q1 ? resData.sample_q1 : '',
							sample_q2: resData.sample_q2 ? resData.sample_q2 : ''
						};
						setAnswers(ansData);
						const loadingData = JSON.parse(JSON.stringify(loadingAns));
						loadingData[qIndex] = false;
						setLoadingAns(loadingData);
						return;
					} else {
						if (resData.corrected_query) {
							const ansData = JSON.parse(JSON.stringify(answers));
							ansData[`${qIndex}`] = {
								message: 'Did you mean:',
								logId: resData.log_id,
								corrected_query: resData.corrected_query ? resData.corrected_query : ''
							};
							setAnswers(ansData);
							const loadingData = JSON.parse(JSON.stringify(loadingAns));
							loadingData[qIndex] = false;
							setLoadingAns(loadingData);
							return;
						} else {
							let payloadProcess = {
								query: message,
								log_id: resData.log_id,
								company_id: companyId,
								user_id: `${userId}`,
								cwd_id: cwdId
							};
							setDisplayMessage('Getting data...')
							processQuery(payloadProcess, qIndex, resData.log_id);
						}
					}
				}
			})
			.catch((error) => {
				const loadingData = JSON.parse(JSON.stringify(loadingAns));
				loadingData[qIndex] = false;
				setLoadingAns(loadingData);
			});
	}

	const processQuery = (payload, qIndex, logId) => {
		ReportAIService.setProcessQuery(payload)
			.then(res => {
				let payloadFinal = {
					log_id: logId,
					company_id: companyId,
					user_id: `${userId}`,
					cwd_id: cwdId,
					query: message,
				};
				setDisplayMessage('Preparing...')
				fetchStreamedChatDataNew(payloadFinal, qIndex);
			})
			.catch((error) => {
				const loadingData = JSON.parse(JSON.stringify(loadingAns));
				loadingData[qIndex] = false;
				setLoadingAns(loadingData);
			});
	}

	const processQueryFromSuggestion = (suggestion, logId, qIndex) => {
		const qData = JSON.parse(JSON.stringify(questions));
		qData[`${qIndex}`] = {
			message: suggestion,
			time: qIndex,
			corrected_query: ''
		};
		setQuestions(qData);
		const loadingData = JSON.parse(JSON.stringify(loadingAns));
		loadingData[qIndex] = true;
		setLoadingAns(loadingData);
		setDisplayMessage('Getting data...');
		let payloadFinal = {
			log_id: logId,
			company_id: companyId,
			user_id: `${userId}`,
			cwd_id: cwdId,
			query: suggestion,
		};
		ReportAIService.setProcessQuery(payloadFinal)
			.then(res => {
				setDisplayMessage('Preparing...')
				fetchStreamedChatDataNew(payloadFinal, qIndex);
			})
			.catch((error) => {
				const loadingData = JSON.parse(JSON.stringify(loadingAns));
				loadingData[qIndex] = false;
				setLoadingAns(loadingData);
			});
	}

	const renderChatMessage = (qIndex) => {
		return (
			<div className='Esg_Chat_qusBox' key={`quesBox-${qIndex}`}>
				<div className='Esg_Chat_qusBox_inner'>

					<div className='Esg_Chat_qusBox_person'>
						<span className='chat_qbox'>
							{Utils.nameInitials(profileData.name)}
						</span>
						{/* <p className="initials-custom"></p> */}
						<h6 className='fw-bold'>
							{questions[qIndex]?.message ?? ''}
						</h6>
					</div>


					{
						loadingAns[qIndex] === true &&

						<div id={`chatMessageLoading`}
							className='mt-2 mb-2'>
							<div className='bot-message w-100'>
								<div className="chat-avatar">
									<img src={esg_ai} />
								</div>
								<div className='chat-message'>
									<div className="spinner-8 me-2"></div> <span>{displayMessage}</span>
								</div>
							</div>
						</div>
					}
					{
						loadingAns[qIndex] !== true &&
						<div className='Esg_Chat_qusBox_AI'>
							<span className='chat_Abox'>
								<img src={esg_ai} />
							</span>
							{errorMessage && !(answers[qIndex]?.message) && (
								<>
									<div className="my-2" style={{ color: '#6b6969' }}>{errorMessage}</div>
								</>

							)}
							<div className='mb-1' dangerouslySetInnerHTML={createMarkup(answers[qIndex]?.message ?? '')}></div>
							{answers[qIndex]?.corrected_query && (
								<>
									<div className='ChatBox_QusBox_list'>
										<ul>
											<li>
												<a href='#' onClick={() => processQueryFromSuggestion(answers[qIndex]?.corrected_query, answers[qIndex]?.logId, qIndex)}>
													<b>{answers[qIndex]?.corrected_query}</b>
												</a>
											</li>
										</ul>
									</div>
								</>
							)}
							{answers[qIndex]?.sample_q1 && (
								<>
									<div className='ChatBox_QusBox_list'>
										<ul>
											<li>
												<i>Example you can ask</i>
												<a href='#' onClick={() => processQueryFromSuggestion(answers[qIndex]?.sample_q1, answers[qIndex]?.logId, qIndex)}>
													<FaHandPointRight /><b> {answers[qIndex]?.sample_q1}</b>
												</a>
												<a href='#' onClick={() => processQueryFromSuggestion(answers[qIndex]?.sample_q2, answers[qIndex]?.logId, qIndex)}>
													<FaHandPointRight /><b> {answers[qIndex]?.sample_q2}</b>
												</a>
											</li>
										</ul>
									</div>
								</>
							)}
							{
								tableOrder >= graphOrder ? (
									<>

										{showgraph[qIndex] && answers[qIndex]?.graphType && answers[qIndex].graphData && (
											<img src={`data:image/jpeg;base64,${answers[qIndex].graphData}`} />
											// renderChart(answers[qIndex].graphType, answers[qIndex].graphData, qIndex)
										)}
										{showTable[qIndex] && answers[qIndex]?.tableContent && (
											<div className='mb-1 Responsivetable_View' dangerouslySetInnerHTML={createMarkups(answers[qIndex]?.tableContent)}></div>
										)}
									</>
								) : (
									<>{showTable[qIndex] && answers[qIndex]?.tableContent && (
										<div className='mb-1 Responsivetable_View' dangerouslySetInnerHTML={createMarkups(answers[qIndex]?.tableContent)}></div>
									)}
										{showgraph[qIndex] && answers[qIndex]?.graphType && answers[qIndex].graphData && (
											<img src={`data:image/jpeg;base64,${answers[qIndex].graphData}`} />
											// renderChart(answers[qIndex].graphType, answers[qIndex].graphData, qIndex)
										)}

									</>
								)
							}

							{

								thoughtsDisplay[qIndex] === true && answers[qIndex]?.thoughts &&
								<div className='p-2 bg-light text-muted rounded'>
									<h6>Thoughts</h6>
									<p className='mb-1' dangerouslySetInnerHTML={createMarkup(answers[qIndex]?.thoughts ?? '')}></p>
								</div>

							}

							{
								(
									<div className='responsive_qusCard'>
										<ul>
											{<li>
												<span className={answers[qIndex]?.tableContent ? '' : 'disabled-icon'}>
													<BsTable onClick={() => {
														setTableOrder(tableOrder + 1)
														const ta = JSON.parse(JSON.stringify(showTable));
														ta[qIndex] = ta[qIndex] === true ? false : true;
														setShowTable(ta);
													}} />
													{/* // <span className={answers[qIndex]?.tableContent ? '' : 'disabled-icon'}>
												// 	<BsTable onClick={() => toggleTableVisibility()} />
												// </span> */}

												</span>
											</li>}

											<li>
												{<>
													<span className={answers[qIndex]?.graphType === 'bar plot' ||
														answers[qIndex]?.graphType === 'bar' ||
														answers[qIndex]?.graphType === 'bar chart' ||
														answers[qIndex]?.graphType === 'pie plot' ||
														answers[qIndex]?.graphType === 'pie' ||
														answers[qIndex]?.graphType === 'pie chart' ||
														answers[qIndex]?.graphType === 'line chart' ||
														answers[qIndex]?.graphType === 'line' ||
														answers[qIndex]?.graphType === 'line plot' ? '' : 'disabled-icon'}>
														<BsGraphDown onClick={() => {
															setGraphOrder(graphOrder + 1)
															const ga = JSON.parse(JSON.stringify(showgraph));
															ga[qIndex] = ga[qIndex] === true ? false : true;
															setShowgraph(ga);

														}} />
													</span>
												</>}
											</li>
											{/* <li className='disabled-icon'><span><BsExclamationTriangle /></span></li> */}
										</ul>
										<ul className='ESGAI_Clipboard-EditeBox'>
											{/* <li>

												<Button variant='secondary' onClick={() => {
													const text = answers[qIndex].message?.replace(/<[^>]*>?/gm, '');
													navigator.clipboard.writeText(text);
													toast.info('Copied');
												}}>
													Copy Content
												</Button>
											</li> */}
											<li>
												<button className='btn btn-secondary'
													onClick={() => dataToTransfer(answers[qIndex], 'text', qIndex)}>
													Transfer Text
												</button>
											</li>
											{showTable[qIndex] && answers[qIndex]?.tableContent &&
												<li>
													<button className='btn btn-secondary'
														onClick={() => dataToTransfer(answers[qIndex], 'table', qIndex)}>
														Transfer Table
													</button>
												</li>
											}
											{showgraph[qIndex] && answers[qIndex]?.graphType &&
												<li>
													<button className='btn btn-secondary'
														onClick={() => dataToTransfer(answers[qIndex], 'graph', qIndex)}>
														Transfer Graph
													</button>
												</li>
											}
										</ul>
									</div>
								)
							}

							<div className='Table_graphViewbox d-none'>
								{/* table and graph data view  */}
							</div>

							<div className='Ai_observationBox d-none'>
								<div className='Ai_observationBox_icon'>
									<BiSolidUpArrow />
								</div>
								<h6 className='AI_observe_head'>ESGAI's processing step to arrive at the solution</h6>
								<div>
									<p className='m-0'>I need to find out the trens in GHG emission</p>
									<p className='m-0'><b>Action :</b> Search the available data.</p>
									<p className='m-0'><b>Observation :</b> Data of GHG eemission for the years 2022, 2023 and 2024 are available</p>
									<p className='m-0'><b>Thought :</b> collection the data, analyse it and compare each value with next and previous year for scope 1, scope 2 and scope 3 emissions. Plot a graph with the findings</p>
								</div>
							</div>
						</div>
					}
				</div>
			</div>
		);

	};

	const feedback = (qIndex, val) => {
		ReportAIService.feedbackFromChatBot({
			company_id: companyId,
			user_id: `${userId}`,
			log_id: answers[qIndex].logId,
			feedback: val
		}).then(res => {
			if (res.status !== 200) return;

			const a = JSON.parse(JSON.stringify(answers));
			a[qIndex]['feedback'] = val;
			setAnswers(a);
			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
		}).catch(err => { });
	};

	const createMarkup = (content) => {
		let formattedContent = content;
		if (content.indexOf('<table>') >= 0) {
			formattedContent = content.replace('<table>', '<table className="table table-bordered">');
		}
		return { __html: formattedContent };
	};

	const createMarkups = (tableContent) => {
		let formattedContent = tableContent;
		if (tableContent.indexOf('table') >= 0) {
			formattedContent = formattedContent.replace('<table border="1" className="dataframe">', '<table  style="border-width: 1px; border-color: rgb(0, 0, 0);" border="1">')
				.replace('<tr style="text-align: right;">', '<tr>')
				.replace(/<th>(.*?)<\/th>/g, (match, p1) => `<th style="border-width: 1px; border-color: rgb(0, 0, 0);">${p1.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}</th>`)
				.replaceAll('<td>', '<td style="border-width: 1px; border-color: rgb(0, 0, 0);">');
		}
		return { __html: formattedContent };
	}

	const renderChart = (graphType, graph, index) => {
		let chart;
		if (graphType === 'bar plot' || graphType === 'bar' || graphType === 'bar chart') {
			const _ = getChartDataAndOptions(graph);
			// Bar chart
			chart = <Bar data={_.data} options={_.options} ref={ref => { chartRef.current[index] = ref }} />;
		} else if (graphType === 'line plot' || graphType === 'line' || graphType === 'line chart') {
			const _ = getChartDataAndOptions(graph);
			chart = <Line data={_.data} options={_.options} ref={ref => { chartRef.current[index] = ref }} />;
		} else if (graphType === 'pie plot' || graphType === 'pie' || graphType === 'pie chart') {
			const _ = getChartDataAndOptionsForPieChart(graph);
			chart = <Doughnut data={_.data} options={_.options} ref={ref => { chartRef.current[index] = ref }} width={400} height={400} />;
		}

		return (
			<div className='pb-1'>
				<div className="fw-bold m-0">{graph?.chart_data?.title}</div>
				<div className={`AI_Chart_graph ${graphType}`} >
					{chart}
				</div>
			</div>
		);
	};

	const getChartDataAndOptions = (graph) => {
		const dpOptions = graph?.chart_data?.dataPoints[0]?.yValues;
		const dataPoints = graph?.chart_data?.dataPoints?.sort((a, b) => a.order - b.order);
		const datasets = [];
		dpOptions?.forEach((option, opIndex) => {
			// Populate data
			const data = [];
			for (let i = 0; i < dataPoints?.length; i++) {
				const dp = dataPoints[i];
				const value = dp.yValues?.find(y => y.label === option.label)?.value ?? 0;
				data.push(value);
			}
			const color = Utils.getChartColorBasedOnIndex(opIndex);
			datasets.push({
				label: option.label,
				borderColor: color.borderColor,
				backgroundColor: color.backgroundColor,
				data: data,
				borderWidth: 1.5,
				dp: option
			});
		});
		const labels = [];
		dataPoints?.forEach(dp => {
			labels.push(dp.xValue);
		});
		const chartData = { labels: labels, datasets: datasets };
		const chartOptions = {
			responsive: true,
			plugins: {
				legend: {
					position: "top",
					align: 'center'
				},
				tooltip: {
					callbacks: {
						label: (tooltipItem) => {
							return ` ${tooltipItem?.dataset?.data[tooltipItem.dataIndex]} ${tooltipItem?.dataset?.dp?.label ?? ''}`;
						}
					}
				}
			}
		};
		return {
			data: chartData,
			options: chartOptions
		};
	};

	const getChartDataAndOptionsForPieChart = (graph) => {
		const dpOptions = graph?.chart_data?.dataPoints[0]?.yValues;
		const dataPoints = graph?.chart_data?.dataPoints?.sort((a, b) => a.order - b.order);
		const data = [], labels = [], borderColors = [], bgColors = [], dps = [];
		dataPoints?.forEach((dp, opIndex) => {
			// Populate data
			data.push(dp.yValues[0]?.value);
			labels.push(dp.xValue);
			const color = Utils.getChartColorBasedOnIndex(opIndex);
			borderColors.push(color.borderColor);
			bgColors.push(color.backgroundColor);
			dps.push(dp);
		});
		const chartData = {
			labels: labels,
			datasets: [{
				label: '',
				data: data,
				backgroundColor: bgColors,
				borderColor: borderColors,
				borderWidth: 1.5,
				dps: dps
			}]
		};
		const chartOptions = {
			responsive: false,
			maintainAspectRatio: false,
			plugins: {
				legend: {
					position: "bottom",
					display: 'center',
					labels: {
						lineWidth: "400px",
					},
				},
				title: {
					display: true,
					text: "",
				},
				tooltip: {
					callbacks: {
						label: (tooltipItem) => {
							return ` ${tooltipItem?.dataset?.data[tooltipItem.dataIndex]} ${tooltipItem?.dataset?.dps[tooltipItem.dataIndex]?.label ?? ''}`;
						}
					}
				}
			}
		};
		return {
			data: chartData,
			options: chartOptions
		};
	};

	const [isActive, setIsActive] = useState(false);
	const [isClicked, setIsClicked] = useState(false);

	const FullscreenView = () => {
		setIsActive(!isActive);

		if (!isActive) {
			// setIsActive(!isActive);
			// setIsClicked(false);
			// setIsDraggable(false);
			// setBoxPosition({ ...boxPosition, x: window.innerWidth - 1080, y: 4 });
		}
		if (isActive) {
			// setIsActive(!isActive);
			// setIsDraggable(true);
			// setBoxPosition({ ...boxPosition, x: window.innerWidth - 510, y: 50 });
		}
	};

	const handleClick = () => {
		setIsClicked(!isClicked); // Toggle the clicked status
	};

	const handleResetPosition = () => {
		// setBoxPosition({ ...boxPosition, x: window.innerWidth - 505, y: 50 });
		setMaximized(!maximized);
		// setIsActive(false);
		// setIsDraggable(true);
	};

	const handleHistoryClicks = (data) => {
		const qIndex = Date.now();
		const qData = {};
		qData[`${qIndex}`] = {
			message: data.user_query,
			time: qIndex
		};
		setQuestions(qData);
		const ansData = {};
		ansData[`${qIndex}`] = {
			message: data.insight,
			graphData: data.graph_data,
			graphType: data.graph_type,
			tableContent: data.html_table_content,
			thoughts: data.chain_of_thoughts
		};
		setAnswers(ansData);
		setIsClicked(!isClicked);
	}

	const errorHandler = (error) => {
		const _ = ReportingUtils.decodeErrorMessage(error?.status, '', t);
		const errorContent = (
			<div>
				<h6>{_.header}</h6>
				<div>{_.message}</div>
			</div>
		);
		toast.error(errorContent, {
			position: toast.POSITION.TOP_RIGHT,
			autoClose: false
		});
		return Promise.reject(error);
	};

	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(false);
		}, 5000);

		return () => clearTimeout(timer);
	}, []);


	return (
		<div>
			{
				maximized &&
				<div className='Report_ChatBox'>
					<button 
						type="button"
						className='history_menu' 
						data-tip="History" 
						data-for="myTooltip"
						onClick={handleClick}
						aria-label="History"
					>
						<BiMenuAltLeft />
					</button>
					{/* <div className='widget-header  text-white header' >

						<div className='widget-header_chat01'>

							<ReactTooltip id="myTooltip" place="bottom" effect="solid" />
							<span className='widget-header_inner' >
								<img src={esg_ai} width={15} height={15} />
								{t('ESGAICopilotChat1.label')}
								<OverlayTrigger
									placement="bottom"
									overlay={
										<Tooltip id="beta-tooltip" className='beta_chatooltipbox'>
											<div className='Beta_box'>
												{t('ESGAI.label')}
												<span className='Beta'>Beta</span>
											</div>
											{t('Welcome.label')}
										</Tooltip>
									}
								>
									<span className='Beta'>Beta</span>
								</OverlayTrigger>

							</span>
						</div>

						<ul>
							

							<li className='FullscreenView'>
								<span className="cursor" onClick={FullscreenView}>
									<BsArrowsFullscreen className={isActive ? 'd-none' : 'd-block'} />
									<BsArrowsAngleContract className={isActive ? 'd-block' : 'd-none'} />
								</span>
							</li>
							<li>
								<span className="cursor" onClick={handleResetPosition}>
									<AiOutlineClose />
								</span>
							</li>
						</ul>
					</div> */}

					<div className='widget-body_main '>
						<div className={isClicked ? 'widget-Chat_historyBoxmain d-block' : 'widget-Chat_historyBoxmain'}>
							<div className="wC_historyBoxmain_inner">
								<button 
									type="button"
									className='Close_btn' 
									onClick={handleClick}
									aria-label="Close"
								>
									<BiX />
								</button>
								<AIChatHistory show={isClicked} companyId={companyId} userId={userId}
									onHistoryDataClick={(data) => handleHistoryClicks(data)}
								/>
							</div>
						</div>
						<div className='widget-body_main_in '>
							<div className='widget-body'>
								{
									Object.keys(questions)?.length === 0 &&
									<div className='widget-body_inner'>
										<div className='Chatbot_welcomeBox'>
											<div className='Chatbot_welcomeBox_in'>
												<img src={esg_green} />
												<h4>{t("ESGAICopilotChatWithData.label")}</h4>
												<p>
													{t("AskQESGFile.label")}
												</p>
											</div>
										</div>
										<div className='ChatBox_QusBox_list'>
											<ul>
												<li>
													<a href='#' onClick={() => setMessage("What was our organization's total carbon emission in the last quarter?")}>
														{t("TipsQuestion1.label")}
													</a>
												</li>
												<li>
													<a href='#' onClick={() => setMessage("What is the average training hours per employee?")}>
													{t("TipsQuestion2.label")}
													</a>
												</li>
												<li>
													<a href='#' onClick={() => setMessage("What is this year's trend in energy consumption within the organization?")}>
													{t("TipsQuestion3.label")}
													</a>
												</li>
												<li>
													<a href='#' onClick={() => setMessage("Total mobile combustion emission in January 2024?")}>
													{t("TipsQuestion4.label")}
													</a>
												</li>
											</ul>

										</div>
									</div>
								}
								{
									Object.keys(questions)?.map((qIndex) => {
										return renderChatMessage(qIndex);
									})
								}
								<div ref={chatEndRef} />
							</div>
							<div className='widget-footer'>
								<div className='widget-footer_inner'>
									<input type='text' className='form-control'
										placeholder={t("AskQuestionPlaceholder.label")}
										value={message}
										onChange={(e) => setMessage(e.target.value)}
										onKeyDown={(e) => onEnterPress(e)} />

									{
										cwdId != null &&
										<div className='Button_box_02'>
											<button 
												type="button"
												className='btn-Chat' 
												onClick={() => sendMessage()}
												aria-label="Send message"
											>
												<MdSend fontSize={25} />
											</button>
										</div>
									}
									{
										cwdId == null &&
										<div className='Button_box_02'>
											<OverlayTrigger
												placement="top"
												overlay={Utils.renderTooltip(t("AIInitializing.label"))}>
												<Spinner
													as="span"
													animation="border"
													size="sm"
													role="status"
													aria-hidden="true"
												/>
											</OverlayTrigger>
										</div>
									}
								</div>
							</div>
							<div className='widget-Disclaimer'>
								<p className='m-0'>
									{
										uiElementsConfig?.texts?.copilotHelp
											? uiElementsConfig?.texts?.copilotHelp
											:
											<>
												{/* <span>{t('AITextGenWidgetFootNote3.label')}</span>
												<span>{t('AITextGenWidgetFootNote2.label')} </span> */}
												{t('AITextGenWidgetFootNote1.label')}

												<div className="Privacy_termsbox">
													<ul>
														<li>
															<a className="" target="_blank" href={uiElementsConfig?.texts?.termsAndConditions ?? "https://ecodrisil.com/terms-of-use"}>
																Terms & Conditions
															</a>
														</li>
														<li>Feedback @ <a href="mailto:copilot@ecodrisil.com">copilot@ecodrisil.com</a>.

														</li>

													</ul>


												</div>

											</>
									}
								</p>
							</div>
						</div>
					</div>
					<Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter"
						centered>
						<Modal.Header closeButton className='border-0'>
							 <Modal.Title as="h5">Upload a file</Modal.Title>
						</Modal.Header>
						<Modal.Body className='border-0'>
							<div className='Drag_Drop_box'>
								<div>Drag & Drop or  <a href='#'> Browse</a></div>
							</div>
						</Modal.Body>
						<Modal.Footer className='border-0 justify-content-center'>

							<Button variant="primary" onClick={handleClose}>
								Upload
							</Button>
						</Modal.Footer>
					</Modal>
				</div>

			}
		</div >
	);
};

export default withTranslation()(AIReportChat);